import { useState } from 'react';
import { toast } from '@/hooks/use-toast';
import { getCurrentPosition, getAddressFromCoordinates } from '@/utils/geoLocationUtils';

export const useGeolocation = () => {
  const [geolocating, setGeolocating] = useState(false);

  const getCurrentLocation = async (): Promise<string | null> => {
    setGeolocating(true);
    
    try {
      const position = await getCurrentPosition();
      const { latitude, longitude } = position.coords;
      
      // Get address from coordinates
      const address = await getAddressFromCoordinates(latitude, longitude);
      return address;
    } catch (error) {
      console.error('Geolocation error:', error);
      toast({
        variant: "destructive",
        title: "Location Error",
        description: typeof error === 'string' ? error : "Could not determine your location.",
      });
      return null;
    } finally {
      setGeolocating(false);
    }
  };

  return { getCurrentLocation, geolocating };
};